export const secondsToMinutes = (seconds: number): string | null => {
  if (seconds === 0) {
    return null; // Return null if seconds is 0
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds} mins | `;
};


export const formatTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

export const getTimestampToDate = (timeStamp: number, isExpiryTime?: boolean): string => {
  const date = isExpiryTime
    ? new Date(timeStamp)
    : new Date(timeStamp * 1000);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const amPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${month}/${day}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
};